import ObjectTypeLIst from './ObjectTypeLIst'

export default ObjectTypeLIst